import lodash from 'lodash';
import {
    call, put, takeEvery, select,
} from 'redux-saga/effects';
import { getLeads } from '../../requests/get_leads_request';
import {
    leadApprovalGetLeadsSuccess,
    leadApprovalGetLeadsFailure,
} from '../actions/lead_approval_get_leads.actions';
import { LEAD_APPROVAL_GET_LEADS } from '../constants/lead_approval_get_leads.constants';

function* leadApprovalGetLeadsRequest({ params }) {
    const store = yield select();
    const userDivisions = lodash.get(store, 'App.App_content.user.divisions') || [];
    const divisionsIds = userDivisions.map(division => division._id);

    const leads = yield call(getLeads, lodash.merge(params || {}, { ref_lead_source: divisionsIds }));
    const { result, options, msg } = leads;

    if (result) {
        yield put(leadApprovalGetLeadsSuccess(options));
    } else {
        yield put(leadApprovalGetLeadsFailure(msg));
    }
}

export default function* leadApprovalGetLeadsSaga() {
    yield takeEvery(LEAD_APPROVAL_GET_LEADS, leadApprovalGetLeadsRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_approval/redux/sagas/lead_approval_get_leads.saga.js